export default __webpack_public_path__ + "static/media/chevron_down.ef525a76.svg";